import { render, staticRenderFns } from "./TransferenciasPremiosImputacionABM.vue?vue&type=template&id=69699f98&"
import script from "./TransferenciasPremiosImputacionABM.vue?vue&type=script&lang=js&"
export * from "./TransferenciasPremiosImputacionABM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports